module.exports = __webpack_public_path__ + "img/Lato-BoldItalic.1dc0cba1.svg";